import React from 'react';
import { Users, BookOpen, Gift, Star } from 'lucide-react';
export function SocialProofBar() {
  return <div className="bg-brand-card text-white py-3 md:py-4 px-3 border-y-2 border-brand-accent" data-id="element-274">
      <div className="max-w-3xl mx-auto grid grid-cols-4 gap-2 md:gap-4" data-id="element-275">
        <div className="flex flex-col items-center text-center" data-id="element-276">
          <Users className="w-4 h-4 md:w-6 md:h-6 mb-1 text-brand-accent" data-id="element-277" />
          <span className="text-sm md:text-lg font-black text-brand-accent" data-id="element-278">
            +300
          </span>
          <span className="text-[9px] md:text-xs text-gray-300 font-bold uppercase" data-id="element-279">
            docentes confían
          </span>
        </div>
        <div className="flex flex-col items-center text-center" data-id="element-280">
          <BookOpen className="w-4 h-4 md:w-6 md:h-6 mb-1 text-brand-accent" data-id="element-281" />
          <span className="text-sm md:text-lg font-black text-brand-accent" data-id="element-282">
            6 Tomos
          </span>
          <span className="text-[9px] md:text-xs text-gray-300 font-bold uppercase" data-id="element-283">
            listos
          </span>
        </div>
        <div className="flex flex-col items-center text-center" data-id="element-284">
          <Gift className="w-4 h-4 md:w-6 md:h-6 mb-1 text-brand-accent" data-id="element-285" />
          <span className="text-sm md:text-lg font-black text-brand-accent" data-id="element-286">
            4 Bonos
          </span>
          <span className="text-[9px] md:text-xs text-gray-300 font-bold uppercase" data-id="element-287">
            incluidos
          </span>
        </div>
        <div className="flex flex-col items-center text-center" data-id="element-288">
          <div className="flex mb-1" data-id="element-289">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 md:w-4 md:h-4 text-brand-accent fill-current" data-id="element-290" />)}
          </div>
          <span className="text-sm md:text-lg font-black text-brand-accent" data-id="element-291">
            4.9/5 ⭐
          </span>
        </div>
      </div>
    </div>;
}